<template>
  <div class="home">
    <div class="top-white-box"></div>
    <div class="top-gray-box">
      <h1>{{settings.blogTitle}}</h1>
    </div>
    <GiveawayBox />
    <Articles />
    
  </div>
</template>

<script>
// @ is an alias to /src
import Articles from '@/components/Articles.vue'
import GiveawayBox from '@/components/GiveawayBox.vue'
import settings from '@/settings'

export default {
  name: 'blog',
  created(){
    document.title = settings.siteNameCaps + ' | ' + settings.siteNameCaps + ' Blog. Read all about deals on our product oriented blog.';
  },
  computed: {
    settings: function(){ return settings; }
  },
  components: {
    Articles,
    GiveawayBox
  }
}
</script>